import request from '@/utils/request'

// 用户分页列表
export function getUserList(params) {
  return request({ url: '/api/user/list', method: 'get', params })
}

// 新增用户
export function addUser(data) {
  return request({ url: '/api/user', method: 'post', data })
}

// 编辑用户
export function updateUser(data) {
  return request({ url: '/api/user', method: 'put', data })
}

// 删除用户
export function deleteUser(id) {
  return request({ url: `/api/user/${id}`, method: 'delete' })
}

// 重置用户密码
export function resetUserPassword(data) {
  return request({ url: '/api/user/resetPassword', method: 'put', data })
}
